import CommonServiceApi from '@/api/commonService/index'
import { from } from 'rxjs';

export default {

    namespaced: true,

    state: {

        sysroomSourceNew$: {}

    },

    getters: {

        sysroomSourceNew$(state) {
            return state.sysroomSourceNew$;
        },

    },

    mutations: {
        setSysroomSourceNew(state, payload) {
            state.sysroomSourceNew$ = payload;
        },

    },

    actions: {

        getSysroomSourceNew({commit}, payload) {
            commit("setSysroomSourceNew", from(CommonServiceApi.getRoomsByAuthSites()));
        }

    },

}